import {
    ThemeProvider,
    createTheme,
    CssBaseline,
    Box,
    Drawer,
    AppBar,
    Toolbar,
    Typography,
    List,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    IconButton,
    Grid,
    Paper,
    TextField,
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    LinearProgress,
    Avatar,
    Menu,
    MenuItem,
    useTheme,
} from "@mui/material";
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    Add as AddIcon,
  } from '@mui/icons-material';
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useState, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import moment from "moment";
import MoreVertIcon from '@mui/icons-material/MoreVert';

import FlexBetween from "components/FlexBetween";

import { useGetEmployeesQuery, useGetAllClockingsQuery, useGetAllBreaksQuery, useDeleteEmployeeMutation, useResetEmployeePinMutation, useUpdateEmployeeMutation, useCreateEmployeeMutation } from "../../state/api";

const Education = () => {
    const theme = useTheme();
    const isMobileScreen = useMediaQuery('(max-width:768px)'); 

    const educations = [
        { 
          dates: '2019 - 2022', 
          institution: 'Alech Computing', 
          qualification: 'Diploma in Databases & Websites', 
          grade: 'D-DD' 
        },
        { 
          dates: '2016 - 2019', 
          institution: 'Institution Name', 
          qualification: 'GCSE General Arts', 
          grade: 'DDD' 
        },
      ];

  return (
    <Box>
        <Paper sx={{ p: 2, borderRadius: '0.75rem' }}>
            <FlexBetween mb={2}>
                <Typography variant="h4">Manage Education</Typography>
                <Button variant="contained" startIcon={<AddIcon />}>Add New Education</Button>
            </FlexBetween>
            <TableContainer>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell>Dates</TableCell>
                    <TableCell>Institution</TableCell>
                    <TableCell>Qualification</TableCell>
                    <TableCell>Grade</TableCell>
                    <TableCell align="right">Actions</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {educations.map(edu => (
                    <TableRow key={edu.institution}>
                        <TableCell>{edu.dates}</TableCell>
                        <TableCell>{edu.institution}</TableCell>
                        <TableCell>{edu.qualification}</TableCell>
                        <TableCell>{edu.grade}</TableCell>
                        <TableCell align="right">
                        <IconButton size="small"><EditIcon /></IconButton>
                        <IconButton size="small"><DeleteIcon /></IconButton>
                        </TableCell>
                    </TableRow>
                    ))}
                </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    </Box>
    )

}

export default Education;

